/*
================================================================ 
     Copyright (c) 2018-2020 Digitize Things Inc.           
           All rights reserved.                       
================================================================ 
*/

import React, { useState, useRef, useEffect } from "react";
import classes from "./css.module.css";
import defaultLogo from "../../../asset/images/digitize-things-logo-transparent.png";
import { connect } from "react-redux";
import Button from "@mui/material/Button";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import Grow from "@mui/material/Grow";
import Paper from "@mui/material/Paper";
import Popper from "@mui/material/Popper";
import MenuItem from "@mui/material/MenuItem";
import MenuList from "@mui/material/MenuList";
import cartIcon from "../../../asset/images/cart.png";
import { withTranslation } from "react-i18next";
import { Avatar, Badge, Divider, ListItemIcon, Tooltip } from "@mui/material";
import jp from "jsonpath";
import BusApiCall from "../../../helper/axios";
import constants from "../../../helper/constants";
import { useLocation } from "react-router-dom";

import ExitToAppOutlinedIcon from "@mui/icons-material/ExitToAppOutlined";
import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import Grid from "@mui/material/Grid";
import Chip from "@mui/material/Chip";
import AuthService from "../../../auth/authService";
import Axios from "axios";
import actionTypes from "../../../store/actions";
import Loader from "../../loader";
import { DefaultLogoImage } from "../../../helper/setFallbackImages";
import { CartBlackIcon, QuoteBlackIcon } from "../../icons/icons";
import ResponsiveDrawer from "./resposiveDrawer";
import { useMediaQuery, useTheme } from "@mui/material";
import LogoutHelper from "../../../helper/logoutHelper";
import { getAppDomain } from "../../../helper/getAppDomain";
import { MyTasks, MyProfile } from "../../icons/icons";
import { useNavigate } from "react-router-dom";
import { styled } from "@mui/material/styles";

// var sideMenu = JSON.parse(localStorage.getItem('sideMenu'));

const StyledButton = styled(Button)(({ theme }) => ({
  // background: 'linear-gradient(45deg, #FE6B8B 30%, #FF8E53 90%)',
  borderRadius: 3,
  border: 0,
  color: "white",
  height: 48,
  padding: "0 30px",
  // boxShadow: '0 3px 5px 2px rgba(255, 105, 135, .3)',
  textTransform: "capitalize",
  "& .MuiButton-label": {
    color: "#073764",
    fontSize: "16px",
  },
}));

const BottomHeader = (props) => {
  const [cartItemCount, setCartItemCount] = useState(0);
  const navigate = useNavigate();
  const location = useLocation();
  const [updatedTenantId, setUpdatedTenantId] = useState("");
  const [updatedLoggedInUserId, setUpdatedLoggedInUserId] = useState("");
  const [updatedAccessToken, setUpdatedAccessToken] = useState("");
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [modules, setModues] = useState({});
  var absoluteDomain = getAppDomain() || "";
  useEffect(() => {
    var modules = JSON.parse(localStorage.getItem("modules"));
    setModues(modules ? modules : {});
    setUpdatedTenantId(props.tenantId);
    setUpdatedLoggedInUserId(props.loggedInUserId);
    setUpdatedAccessToken(props.access_token);
    let count = jp.query(
      props.solutionList,
      '$..[?(@.tenantId=="' + props.tenantId + '")]',
    ).length;
    setCartItemCount(count);
    setGenericReportsList(props.genericReports);
  }, [location]);

  const [genericReportsList, setGenericReportsList] = useState([]);
  const [showLoading, setLoading] = useState(false);
  const openOperPortal = (token, tenantId) => {
    // window.open(`${constants.cbizBaseUrl}/myportal/control/main?8f1-550-3c7-e8f=` + token + "&userTenantId=" + tenantId + "&57b-7ad-d6b-80c=582-204-65e-be0&userId=" + props.loggedInUserId);
    // window.open(`${constants.cbizBaseUrl}/myportal/control/checkLogin`);
    setLoading(true);
    var tokenInfo = JSON.parse(localStorage.getItem("tokenInfo"));
    var userRoles = JSON.parse(localStorage.getItem("roles"));
    var tenantInfo = props.tenantInfo;
    var url = "";
    if (tenantInfo.tenantId) {
      var authority = tenantInfo.baseUrl + tenantInfo.tokenUrl;
      var tempUrl = authority.replace("${}", tenantInfo.realm);
      url = tempUrl.replace("token", "userinfo");
    } else {
      url = tenantInfo.authority.split("token")[0] + "userinfo";
    }
    let headers = {
      Authorization: "Bearer " + props.access_token,
    };
    Axios.get(url, { headers })
      .then((response) => {
        setUpdatedTenantId(userRoles.data.tenantId);
        setUpdatedLoggedInUserId(props.loggedInUserId);
        setUpdatedAccessToken(props.access_token);
        BusApiCall("POST", `${constants.busPublicServiceUrl}/auth/token`)
          .then((res) => {
            if (
              window.location.protocol === "https:" ||
              window.location.protocol === "HTTPS:"
            ) {
              document.cookie =
                "access_token=" +
                tokenInfo.access_token +
                "; domain=" +
                absoluteDomain +
                "; path=/; secure;";
              document.cookie =
                "id_token_hint=" +
                tokenInfo.id_token +
                "; domain=" +
                absoluteDomain +
                "; path=/; secure;";
              document.cookie =
                "refresh_token=" +
                tokenInfo.refresh_token +
                "; domain=" +
                absoluteDomain +
                "; path=/; secure;";
              document.cookie =
                "user_login_id=" +
                userRoles.data.loggedInUser.userId +
                "; domain=" +
                absoluteDomain +
                "; path=/; secure;";
              document.cookie =
                "tenantId=" +
                userRoles.data.tenantId +
                "; domain=" +
                absoluteDomain +
                "; path=/; secure;";
              document.cookie =
                "sharedToken=true; domain=" +
                absoluteDomain +
                "; path=/; secure;";
              document.cookie =
                "tenantInfo=" +
                JSON.stringify(tenantInfo) +
                "; domain=" +
                absoluteDomain +
                "; path=/; secure;";
            } else {
              document.cookie =
                "access_token=" +
                tokenInfo.access_token +
                "; domain=" +
                absoluteDomain +
                "; path=/;";
              document.cookie =
                "id_token_hint=" +
                tokenInfo.id_token +
                "; domain=" +
                absoluteDomain +
                "; path=/;";
              document.cookie =
                "refresh_token=" +
                tokenInfo.refresh_token +
                "; domain=" +
                absoluteDomain +
                "; path=/;";
              document.cookie =
                "user_login_id=" +
                userRoles.data.loggedInUser.userId +
                "; domain=" +
                absoluteDomain +
                "; path=/;";
              document.cookie =
                "tenantId=" +
                userRoles.data.tenantId +
                "; domain=" +
                absoluteDomain +
                "; path=/;";
              document.cookie =
                "sharedToken=true; domain=" + absoluteDomain + "; path=/;";
              document.cookie =
                "tenantInfo=" +
                JSON.stringify(tenantInfo) +
                "; domain=" +
                absoluteDomain +
                "; path=/;";
            }
            if (operationLinkButtonRef.current) {
              operationLinkButtonRef.current.click();
            }
            setLoading(false);
          })
          .catch((error) => {
            var time = 5;
            setInterval(() => {
              if (time > -1) {
                props.setErrorMessage(
                  props.t("SESSION_EXPIRED_ERROR") + " in " + time,
                  false,
                );
                time = time - 1;
                setLoading(false);
              }
              if (time === 0) {
                logout();
              }
            }, 1000);
          });
      })
      .catch((error) => {
        var time = 5;
        setInterval(() => {
          if (time > -1) {
            props.setErrorMessage(
              props.t("SESSION_EXPIRED_ERROR") + " in " + time,
              false,
            );
            time = time - 1;
            setLoading(false);
          }
          if (time === 0) {
            logout();
          }
        }, 1000);
      });
  };
  const logout = () => {
    LogoutHelper();
  };
  const [orderOpen, setOrderOpen] = useState(false);
  const anchorRefOrder = useRef(null);
  const operationLinkButtonRef = useRef(null);
  const handleOrderExpand = () => {
    //setOrderOpen((prevOpen) => !prevOpen);
    setOrderOpen(true);
    setSolOpen(false);
    setAvOpen(false);
    setSerOpen(false);
  };
  const handleOrderCollapse = () => {
    setOrderOpen(false);
  };
  const handleOrderClose = (event) => {
    if (
      anchorRefOrder.current &&
      anchorRefOrder.current.contains(event.target)
    ) {
      return;
    }
    setOrderOpen(false);
  };

  function handleOrderListKeyDown(event) {
    if (event.key === "Tab") {
      event.preventDefault();
      setOrderOpen(false);
    }
  }

  const [solOpen, setSolOpen] = useState(false);
  const anchorRefSol = useRef(null);
  const handleSolExpand = () => {
    //setSolOpen((prevOpen) => !prevOpen);
    setSolOpen(true);
    setOrderOpen(false);
    setAvOpen(false);
    setSerOpen(false);
  };
  const handleSolCollapse = () => {
    setSolOpen(false);
  };
  const handleSolClose = (event) => {
    if (anchorRefSol.current && anchorRefSol.current.contains(event.target)) {
      return;
    }
    setSolOpen(false);
  };

  function handleSolListKeyDown(event) {
    if (event.key === "Tab") {
      event.preventDefault();
      setSolOpen(false);
    }
  }

  const [serOpen, setSerOpen] = useState(false);
  const anchorRefSer = useRef(null);
  const handleSerExpand = () => {
    //setSolOpen((prevOpen) => !prevOpen);
    setSerOpen(true);
    setOrderOpen(false);
    setAvOpen(false);
    setSolOpen(false);
  };
  const handleSerCollapse = () => {
    setSerOpen(false);
  };
  const handleSerClose = (event) => {
    if (anchorRefSer.current && anchorRefSer.current.contains(event.target)) {
      return;
    }
    setSerOpen(false);
  };

  function handleSerListKeyDown(event) {
    if (event.key === "Tab") {
      event.preventDefault();
      setSerOpen(false);
    }
  }

  const [avOpen, setAvOpen] = useState(false);
  const [avReportOpen, setAvReportOpen] = useState(false);
  const anchorRefAv = useRef(null);
  const anchorRefReportAv = useRef(null);
  const handleAvExpand = () => {
    //setSolOpen((prevOpen) => !prevOpen);
    setAvOpen(true);
    setAvReportOpen(false);
    setOrderOpen(false);
    setSolOpen(false);
    setSerOpen(false);
  };
  const handleAvReportExpand = () => {
    //setSolOpen((prevOpen) => !prevOpen);
    setAvOpen(false);
    setAvReportOpen(true);
    setOrderOpen(false);
    setSolOpen(false);
    setSerOpen(false);
  };
  const handleAvClose = (event) => {
    if (anchorRefAv.current && anchorRefAv.current.contains(event.target)) {
      return;
    }
    setAvOpen(false);
  };

  const handleAvReportClose = (event) => {
    if (
      anchorRefReportAv.current &&
      anchorRefReportAv.current.contains(event.target)
    ) {
      return;
    }
    setAvReportOpen(false);
  };

  function handleAvListKeyDown(event) {
    if (event.key === "Tab") {
      event.preventDefault();
      setAvOpen(false);
    }
  }

  function handleAvReportListKeyDown(event) {
    if (event.key === "Tab") {
      event.preventDefault();
      setAvReportOpen(false);
    }
  }

  const [open, setOpen] = useState(false);
  const anchorRef = useRef(null);

  var extension = undefined;
  if (props.tenantData.logo) {
    if (props.tenantData.logo.startsWith("data:image")) {
      extension = "";
    } else {
      let decoded = atob(decodeURIComponent(props.tenantData.logo));
      var lowerCase = decoded.toLowerCase();
      if (lowerCase.indexOf("png") === 1) {
        extension = "png";
      } else if (
        lowerCase.indexOf("jpg") === 1 ||
        lowerCase.indexOf("jpeg") === 1
      ) {
        extension = "jpg";
      } else if (lowerCase.includes("svg")) {
        extension = "svg+xml";
      } else if (
        lowerCase.indexOf("tif") === 1 ||
        lowerCase.indexOf("tiff") === 1
      ) {
        extension = "tiff";
      }
    }
  }
  const closeOthers = () => {
    setSerOpen(false);
    setOrderOpen(false);
    setAvOpen(false);
    setSolOpen(false);
    setAvReportOpen(false);
  };
  const getInitials = (name) => {
    if (name) {
      const words = name.split(" ");
      const initials = words.map((word) => word.replace(/[^a-zA-Z]/g, "")[0]);
      return initials.slice(0, 2).join("");
    }
  };
  // var sideMenu = JSON.parse(localStorage.getItem('sideMenu'));
  var sideMenu = props.sideMenu;
  var preSelectedCustomer = JSON.parse(
    localStorage.getItem("preSelectedCustomer"),
  );

  return (
    <>
      <div
        className={sideMenu ? "newTopHeaderSideMenu" : "newTopHeader"}
        style={{
          display: sideMenu ? "" : "flex",
          justifyContent: sideMenu ? "" : "space-between",
        }}
      >
        <div
          className={classes.topHeaderLogo}
          align="left"
          style={{ display: sideMenu ? "none" : "block" }}
        >
          <a href="/">
            {props.tenantData.logo ? (
              // <img
              // 	onError={DefaultLogoImage}
              // 	src={"data:image/" + extension + ";base64," + encodeURIComponent(props.tenantData.logo)}
              // 	alt={props.tenantData.title}
              // />
              <>
                {props.tenantData.logo.startsWith("data:image") ? (
                  <img
                    onError={DefaultLogoImage}
                    src={props.tenantData.logo}
                    alt={props.tenantData.title}
                  />
                ) : (
                  <img
                    onError={DefaultLogoImage}
                    src={
                      "data:image/" +
                      extension +
                      ";base64," +
                      encodeURIComponent(props.tenantData.logo)
                    }
                    alt={props.tenantData.title}
                  />
                )}
              </>
            ) : (
              <img
                src={""}
                onError={DefaultLogoImage}
                alt={props.t("ADMIN_TENANT")}
              />
            )}
          </a>
        </div>
        <div
          className={classes.topHeaderCart}
          align="right"
          style={{ width: "100%" }}
        >
          {!props.publicBrowsing && (
            <label onMouseLeave={closeOthers}>
              {/* <label> */}
              {isMobile ? "" : ""}
              <StyledButton
                ref={anchorRefAv}
                aria-controls={open ? "menu-list-av" : undefined}
                aria-haspopup="true"
                // onClick={(e) => { closeOthers(); handleAvExpand() }}
                onMouseEnter={(e) => {
                  closeOthers();
                  handleAvExpand();
                }}
                onClick={(e) => {
                  closeOthers();
                  handleAvExpand();
                }}
              >
                <span
                  className={"topUserInfo"}
                  style={{
                    display: "flex",
                    gap: "1rem",
                    alignItems: "flex-end",
                  }}
                >
                  <div style={{ textAlign: "end" }}>
                    <div
                      style={{
                        fontSize: "16px",
                        fontWeight: "bold",
                        lineHeight: "1",
                      }}
                    >
                      {props.loggedInUserType === "ECOMMERCE_CUSTOMER" ||
                        props.loggedInUserType === "ECOMMERCE_ADMIN"
                        ? props.ecommerceCustData
                          ? props.ecommerceCustData.accountName
                          : ""
                        : props.loggedInUserName
                          ? props.loggedInUserName
                          : props.providerName}
                    </div>
                    <div
                      style={{
                        color: "#393939",
                        fontSize: "12px",
                        textTransform: "none",
                      }}
                    >
                      {props.loggedInUserId}
                    </div>
                  </div>
                  {props.loggedInUserType === "ECOMMERCE_CUSTOMER" ||
                    props.loggedInUserType === "ECOMMERCE_ADMIN" ? (
                    // (props.ecommerceCustData ? props.ecommerceCustData.accountName : '')
                    // :
                    // props.loggedInUserName ? props.loggedInUserName : props.providerName
                    props.ecommerceCustData ? (
                      <Avatar
                        style={{ backgroundColor: "var(--primary-color)" }}
                      >
                        {getInitials(props.ecommerceCustData.accountName)}
                      </Avatar>
                    ) : (
                      ""
                    )
                  ) : props.loggedInUserName ? (
                    <Avatar style={{ backgroundColor: "var(--primary-color)" }}>
                      {getInitials(props.loggedInUserName)}
                    </Avatar>
                  ) : (
                    <Avatar style={{ backgroundColor: "var(--primary-color)" }}>
                      {getInitials(props.providerName)}
                    </Avatar>
                  )}
                  {/* {props.ecommerceCustData && props.ecommerceCustData.firstName ? props.ecommerceCustData.firstName + ' ' + props.ecommerceCustData.lastName : props.providerName} */}
                </span>
              </StyledButton>
              <Popper
                open={avOpen}
                anchorEl={anchorRefAv.current}
                role={undefined}
                transition
                disablePortal
                placement="bottom-end"
                style={{ zIndex: "999" }}
              >
                {({ TransitionProps, placement }) => (
                  <Grow
                    {...TransitionProps}
                  // style={{ transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom' }}
                  >
                    <Paper className={"custom_drop_down_ui custom_menu_width"}>
                      <ClickAwayListener onClickAway={handleAvClose}>
                        <MenuList
                          autoFocusItem={avOpen}
                          id="menu-list-av"
                          onKeyDown={handleAvListKeyDown}
                        >
                          <Grid
                            container
                            spacing={1}
                            direction="row"
                            alignItems="left"
                          >
                            {/* <Grid item xs={12} style={{ marginLeft: "6px", lineHeight: "1.5", textAlign: "left" }}>
															<div style={{ fontSize: "16px", fontWeight: "bold" }}>
																{props.loggedInUserType === "ECOMMERCE_CUSTOMER" || props.loggedInUserType === "ECOMMERCE_ADMIN"
																	? props.ecommerceCustData
																		? props.ecommerceCustData.accountName
																		: ""
																	: props.loggedInUserName
																		? props.loggedInUserName
																		: props.providerName}
															</div>
															<div style={{ color: "#393939", fontSize: "12px" }}>{props.loggedInUserId}</div>
														</Grid> */}
                            {/* <Divider variant='middle' style={{ marginTop: '.5rem', marginBottom: '.5rem' }} /> */}

                            <Grid
                              item
                              style={{
                                marginLeft: "0px",
                                lineHeight: "2.0",
                                textAlign: "left",
                              }}
                              size={{
                                xs: 12,
                              }}
                            >
                              <div>
                                <>
                                  {props.loggedInUserType ===
                                    "ECOMMERCE_CUSTOMER" ||
                                    props.loggedInUserType ===
                                    "ECOMMERCE_ADMIN" ? (
                                    <Chip
                                      size="normal"
                                      style={{ width: "100%" }}
                                      label={props.t(props.loggedInUserType)}
                                    />
                                  ) : (
                                    <Chip
                                      size="normal"
                                      style={{ width: "100%" }}
                                      label={props.t(props.providerType)}
                                    />
                                  )}
                                </>
                              </div>
                            </Grid>
                          </Grid>
                          <Grid
                            item
                            style={{
                              marginLeft: "6px",
                              lineHeight: "2.0",
                              textAlign: "left",
                            }}
                          >
                            <div style={{ color: "#393939", fontSize: "14px" }}>
                              {props.tenantData.title.charAt(0).toUpperCase() +
                                props.tenantData.title.slice(1)}
                            </div>
                          </Grid>
                          <Divider
                            style={{
                              marginTop: ".5rem",
                              marginBottom: ".5rem",
                            }}
                          />
                          <MenuItem
                            onClick={(e) => {
                              handleAvClose(e);
                              {
                                props.loggedInUserType ===
                                  "ECOMMERCE_CUSTOMER" ||
                                  props.loggedInUserType === "ECOMMERCE_ADMIN"
                                  ? navigate("/myProfile")
                                  : // navigate("/profile");
                                  navigate("/profile", { replace: true });
                              }
                            }}
                            style={{ display: "flex", alignItems: "center" }}
                          >




                            <ListItemIcon style={{ display: "contents" }}>
                              {/* <AccountCircleOutlinedIcon fontSize="small" /> */}
                              <MyProfile />
                            </ListItemIcon>
                            <span
                              style={{ marginLeft: "16px", textAlign: "left" }}
                            >
                              {props.t("MY_PROFILE")}
                            </span>
                          </MenuItem>
                          <Divider
                            style={{ marginTop: "8px", marginBottom: "12px" }}
                          />
                          {/* {props.loggedInUserType === "ECOMMERCE_CUSTOMER" || props.loggedInUserType === "ECOMMERCE_ADMIN" ? null
															:
															<>
																<MenuItem
																	onClick={(e) => {
																		handleAvClose(e);
																		{ window.location.replace('/profile?type=task') }
																	}}
																	style={{ display: "flex", alignItems: "center" }}
																>
																	<ListItemIcon style={{ display: "contents" }}>
																		<MyTasks />
																	</ListItemIcon>
																	<span style={{ marginLeft: "16px", textAlign: "left" }}>{props.t("MY_TASK")}</span>
																</MenuItem>
																<Divider style={{ marginTop: "8px", marginBottom: "12px" }} />
															</>
														} */}
                          <MenuItem
                            onClick={(e) => {
                              handleAvClose(e);
                              props.logout();
                            }}
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            <ListItemIcon style={{ display: "contents" }}>
                              <ExitToAppOutlinedIcon
                                style={{ color: "#FF6961" }}
                                fontSize="small"
                              />
                            </ListItemIcon>
                            <span
                              style={{ marginLeft: "16px", textAlign: "left" }}
                            >
                              {props.t("SIGN_OUT")}
                            </span>
                          </MenuItem>
                        </MenuList>
                      </ClickAwayListener>
                    </Paper>
                  </Grow>
                )}
              </Popper>
            </label>
          )}
          {props.publicBrowsing && (
            <>
              <span
                onClick={(e) => {
                  window.localStorage.setItem("doLogin", true);
                  window.location.reload();
                }}
                style={{
                  color: props.tenantData.color
                    ? props.tenantData.color
                    : "#003161",
                  cursor: "pointer",
                }}
              >
                {props.t("SIGN_IN")}
              </span>
              <span
                style={{
                  color: props.tenantData.color
                    ? props.tenantData.color
                    : "#003161",
                  margin: "0 15px",
                }}
              >
                &nbsp;|&nbsp;
              </span>
              <span
                onClick={(e) => {
                  navigate("/signUp");
                }}
                style={{
                  color: props.tenantData.color
                    ? props.tenantData.color
                    : "#003161",
                  cursor: "pointer",
                }}
              >
                {props.t("SIGN_UP")}
              </span>
            </>
          )}
          {!props.publicBrowsing && (
            <>
              <span className={"topUserInfo"} style={{ margin: "0 15px" }}>
                &nbsp;|
              </span>
              <Tooltip title={props.t("MY_TASK")}>
                <span
                  style={{ cursor: "pointer" }}
                  onClick={(e) => {
                    navigate("/profile?type=task", { replace: true })
                  }}
                  // onClick={(e) => {
                  //   handleAvClose(e);
                  //   {
                  //     window.location.replace("/profile?type=task");
                  //   }
                  // }}
                >
                  <Badge
                    badgeContent={
                      props.pendingTaskCount ? +props.pendingTaskCount : 0
                    }
                    max={9}
                    color="primary"
                    className="cartBadgeIcon tasksBadgeIcon"
                    overlap={"rectangular"}
                  >
                    <MyTasks />
                  </Badge>
                </span>
              </Tooltip>
              <span
                className={"topUserInfo"}
                style={{
                  marginRight:
                    props.pendingTaskCount && +props.pendingTaskCount > 9
                      ? "20px"
                      : "15px",
                }}
              >
                &nbsp;
              </span>
            </>
          )}
          {/* {!props.publicBrowsing && props.menuPaths.includes("/cart") && (
						<span className={"topUserInfo"} style={{ margin: "0 15px" }}>
							&nbsp;|
						</span>
					)} */}
          {props.providerType === "SALES_CHNL_PROVIDER" && (
            <>
              {preSelectedCustomer && preSelectedCustomer.ban ? (
                <>
                  {(props.menuPaths.includes("/cart") ||
                    props.publicBrowsing) &&
                    modules.module_quote !== "enabled" &&
                    // (props.providerType === 'SALES_CHNL_PROVIDER' || props.providerType === 'SOLUTION_PROVIDER') &&
                    props.shoppingCart &&
                    Array.isArray(props.shoppingCart) &&
                    props.shoppingCart.length > 0 &&
                    props.shoppingCart[0].cartItem &&
                    preSelectedCustomer &&
                    preSelectedCustomer.ban && (
                      <>
                        <Tooltip title={props.t("CART")}>
                          <Badge
                            badgeContent={props.shoppingCart[0].cartItem.length}
                            color="primary"
                            className="cartBadgeIcon"
                            overlap={"rectangular"}
                          >
                            {/* <img onClick={(e) => { navigate('/cart') }} style={{ cursor: 'pointer' }} src={cartIcon} /> */}
                            <svg
                              width="23"
                              height="20"
                              viewBox="0 0 13 12"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                              onClick={(e) => {
                                navigate("/cart");
                              }}
                              style={{ cursor: "pointer" }}
                            >
                              <g clipPath="url(#clip0_36_5803)">
                                <path
                                  fillRule="evenodd"
                                  clipRule="evenodd"
                                  d="M2.48535 1.50001H1.95508C1.67894 1.50001 1.45508 1.27615 1.45508 1.00001C1.45508 0.723863 1.67894 0.500006 1.95508 0.500006H2.5793C2.58292 0.500006 2.5866 0.500004 2.59033 0.500003C2.64651 0.499981 2.71428 0.499955 2.77426 0.504725C2.84429 0.510295 2.94332 0.524533 3.04814 0.575493C3.18483 0.641948 3.29811 0.748366 3.37296 0.880649C3.43036 0.982087 3.45075 1.08003 3.46067 1.14958C3.46918 1.20914 3.47338 1.27678 3.47686 1.33285C3.47709 1.33658 3.47732 1.34025 3.47755 1.34386L3.51855 2.00001L11.5207 2C11.5868 1.99998 11.6641 1.99995 11.7316 2.0057C11.8087 2.01226 11.9219 2.0292 12.0382 2.09342C12.1869 2.17546 12.3032 2.30549 12.3684 2.46224C12.4193 2.58495 12.4237 2.69938 12.4217 2.77666C12.4199 2.84443 12.4114 2.9213 12.4041 2.98694L12.1082 5.6498C12.0819 5.88619 12.0591 6.0914 12.027 6.26023C11.9928 6.43941 11.9419 6.61542 11.8398 6.78237C11.6864 7.03331 11.4626 7.23362 11.1963 7.35838C11.0191 7.44138 10.8385 7.47256 10.6567 7.4867C10.4853 7.50002 10.2788 7.50001 10.041 7.50001H3.8623L3.9248 8.50001H10.4551C10.7312 8.50001 10.9551 8.72386 10.9551 9.00001C10.9551 9.27615 10.7312 9.50001 10.4551 9.50001L3.81984 9.50001C3.76366 9.50003 3.69588 9.50006 3.6359 9.49529C3.56587 9.48972 3.46684 9.47548 3.36202 9.42452C3.22533 9.35806 3.11205 9.25165 3.0372 9.11936C2.9798 9.01793 2.95941 8.91998 2.94948 8.85043C2.94098 8.79087 2.93678 8.72323 2.9333 8.66716C2.93307 8.66343 2.93284 8.65976 2.93261 8.65615L2.48535 1.50001ZM2.47949 1.40624L2.52291 1.40353C2.53884 1.42401 2.55787 1.44188 2.5793 1.45651C2.58933 1.46335 2.59989 1.46949 2.61091 1.47484C2.63679 1.48743 2.65979 1.49441 2.67624 1.49815C2.6885 1.50094 2.6961 1.50168 2.6961 1.50168L2.69498 1.50158M3.7998 6.50001H10.023C10.284 6.50001 10.4512 6.49966 10.5792 6.48971C10.7009 6.48024 10.7477 6.46422 10.7721 6.4528C10.8609 6.41121 10.9355 6.34444 10.9866 6.2608C11.0007 6.23783 11.0218 6.19306 11.0446 6.07309C11.0686 5.94703 11.0875 5.78085 11.1163 5.52148L11.3964 3.00001H3.58105L3.7998 6.50001ZM3.95508 10.75C3.95508 10.3358 4.29086 10 4.70508 10C5.11929 10 5.45508 10.3358 5.45508 10.75C5.45508 11.1642 5.11929 11.5 4.70508 11.5C4.29086 11.5 3.95508 11.1642 3.95508 10.75ZM8.45508 10.75C8.45508 10.3358 8.79086 10 9.20508 10C9.61929 10 9.95508 10.3358 9.95508 10.75C9.95508 11.1642 9.61929 11.5 9.20508 11.5C8.79086 11.5 8.45508 11.1642 8.45508 10.75Z"
                                  fill="currentColor"
                                />
                              </g>
                              <defs>
                                <clipPath id="clip0_36_5803">
                                  <rect
                                    width="12"
                                    height="12"
                                    fill="white"
                                    transform="translate(0.955078)"
                                  />
                                </clipPath>
                              </defs>
                            </svg>
                            {/* <svg
														width="21"
														height="21"
														viewBox="0 0 32 32"
														fill="none"
														xmlns="http://www.w3.org/2000/svg"
														onClick={(e) => {
															navigate("/cart");
														}}
														style={{ cursor: "pointer" }}
													>
														<g clipPath="url(#clip0_1076_1137)">
															<path
																d="M10 30C11.1046 30 12 29.1046 12 28C12 26.8954 11.1046 26 10 26C8.89543 26 8 26.8954 8 28C8 29.1046 8.89543 30 10 30Z"
																fill="black"
															/>
															<path
																d="M24 30C25.1046 30 26 29.1046 26 28C26 26.8954 25.1046 26 24 26C22.8954 26 22 26.8954 22 28C22 29.1046 22.8954 30 24 30Z"
																fill="black"
															/>
															<path
																d="M4.9806 2.8039C4.93527 2.57721 4.81279 2.37322 4.63401 2.22666C4.45522 2.08009 4.23118 2 4 2H0V4H3.18L7.0194 23.1961C7.06473 23.4228 7.18721 23.6268 7.36599 23.7733C7.54478 23.9199 7.76882 24 8 24H26V22H8.82L8.02 18H26C26.2275 18 26.4482 17.9224 26.6257 17.7801C26.8032 17.6377 26.9268 17.4391 26.9762 17.217L29.2445 7H27.1971L25.1982 16H7.62L4.9806 2.8039Z"
																fill="black"
															/>
														</g>
														<defs>
															<clipPath id="clip0_1076_1137">
																<rect width="32" height="32" fill="white" />
															</clipPath>
														</defs>
													</svg> */}
                          </Badge>
                        </Tooltip>
                      </>
                    )}

                  {(props.menuPaths.includes("/cart") ||
                    props.publicBrowsing) &&
                    modules.module_quote !== "enabled" &&
                    // (props.providerType === 'SALES_CHNL_PROVIDER' || props.providerType === 'SOLUTION_PROVIDER') &&
                    props.shoppingCart &&
                    Array.isArray(props.shoppingCart) &&
                    props.shoppingCart.length === 0 && (
                      <>
                        <Tooltip title={props.t("CART")}>
                          <Badge
                            badgeContent={0}
                            color="primary"
                            className="cartBadgeIcon"
                            overlap={"rectangular"}
                          >
                            {/* <img onClick={(e) => { navigate('/cart') }} style={{ cursor: 'pointer' }} src={cartIcon} /> */}
                            <svg
                              width="21"
                              height="21"
                              viewBox="0 0 32 32"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                              onClick={(e) => {
                                navigate("/cart");
                              }}
                              style={{ cursor: "pointer" }}
                            >
                              <g clipPath="url(#clip0_1076_1137)">
                                <path
                                  d="M10 30C11.1046 30 12 29.1046 12 28C12 26.8954 11.1046 26 10 26C8.89543 26 8 26.8954 8 28C8 29.1046 8.89543 30 10 30Z"
                                  fill="black"
                                />
                                <path
                                  d="M24 30C25.1046 30 26 29.1046 26 28C26 26.8954 25.1046 26 24 26C22.8954 26 22 26.8954 22 28C22 29.1046 22.8954 30 24 30Z"
                                  fill="black"
                                />
                                <path
                                  d="M4.9806 2.8039C4.93527 2.57721 4.81279 2.37322 4.63401 2.22666C4.45522 2.08009 4.23118 2 4 2H0V4H3.18L7.0194 23.1961C7.06473 23.4228 7.18721 23.6268 7.36599 23.7733C7.54478 23.9199 7.76882 24 8 24H26V22H8.82L8.02 18H26C26.2275 18 26.4482 17.9224 26.6257 17.7801C26.8032 17.6377 26.9268 17.4391 26.9762 17.217L29.2445 7H27.1971L25.1982 16H7.62L4.9806 2.8039Z"
                                  fill="black"
                                />
                              </g>
                              <defs>
                                <clipPath id="clip0_1076_1137">
                                  <rect width="32" height="32" fill="white" />
                                </clipPath>
                              </defs>
                            </svg>
                          </Badge>
                        </Tooltip>
                      </>
                    )}
                </>
              ) : (
                <>
                  {props.menuPaths.includes("/cart") &&
                    modules.module_quote !== "enabled" && (
                      <>
                        <Tooltip title={props.t("CART")}>
                          <Badge
                            badgeContent={0}
                            color="primary"
                            className="cartBadgeIcon"
                            overlap={"rectangular"}
                          >
                            {/* <img onClick={(e) => { navigate('/cart') }} style={{ cursor: 'pointer' }} src={cartIcon} /> */}
                            <svg
                              width="21"
                              height="21"
                              viewBox="0 0 32 32"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                              onClick={(e) => {
                                navigate("/cart");
                              }}
                              style={{ cursor: "pointer" }}
                            >
                              <g clipPath="url(#clip0_1076_1137)">
                                <path
                                  d="M10 30C11.1046 30 12 29.1046 12 28C12 26.8954 11.1046 26 10 26C8.89543 26 8 26.8954 8 28C8 29.1046 8.89543 30 10 30Z"
                                  fill="black"
                                />
                                <path
                                  d="M24 30C25.1046 30 26 29.1046 26 28C26 26.8954 25.1046 26 24 26C22.8954 26 22 26.8954 22 28C22 29.1046 22.8954 30 24 30Z"
                                  fill="black"
                                />
                                <path
                                  d="M4.9806 2.8039C4.93527 2.57721 4.81279 2.37322 4.63401 2.22666C4.45522 2.08009 4.23118 2 4 2H0V4H3.18L7.0194 23.1961C7.06473 23.4228 7.18721 23.6268 7.36599 23.7733C7.54478 23.9199 7.76882 24 8 24H26V22H8.82L8.02 18H26C26.2275 18 26.4482 17.9224 26.6257 17.7801C26.8032 17.6377 26.9268 17.4391 26.9762 17.217L29.2445 7H27.1971L25.1982 16H7.62L4.9806 2.8039Z"
                                  fill="black"
                                />
                              </g>
                              <defs>
                                <clipPath id="clip0_1076_1137">
                                  <rect width="32" height="32" fill="white" />
                                </clipPath>
                              </defs>
                            </svg>
                          </Badge>
                        </Tooltip>
                      </>
                    )}
                </>
              )}
              {(props.menuPaths.includes("/cart") || props.publicBrowsing) &&
                modules.module_quote === "enabled" &&
                props.providerType === "SALES_CHNL_PROVIDER" && (
                  <Tooltip title={props.t("QUOTE")}>
                    <span>
                      <Badge
                        badgeContent={
                          props.shoppingQuote &&
                            props.shoppingQuote.length > 0 &&
                            props.shoppingQuote[0].cartItem &&
                            props.shoppingQuote[0].cartItem.length > 0
                            ? props.shoppingQuote[0].cartItem.length
                            : 0
                        }
                        max={9}
                        color="primary"
                        className="cartBadgeIcon"
                        overlap={"rectangular"}
                      >
                        {/* <img onClick={(e) => { navigate('/cart') }} style={{ cursor: 'pointer' }} src={cartIcon} /> */}
                        {/* <svg width="21" height="21" viewBox="0 0 32 32" fill="none"
                                xmlns="http://www.w3.org/2000/svg" onClick={(e) => { navigate('/quote') }} style={{ cursor: 'pointer', marginLeft: '15px' }}>
                                <g clipPath="url(#clip0_1076_1131)">
                                    <path d="M10 30C11.1046 30 12 29.1046 12 28C12 26.8954 11.1046 26 10 26C8.89543 26 8 26.8954 8 28C8 29.1046 8.89543 30 10 30Z" fill="black" />
                                    <path d="M24 30C25.1046 30 26 29.1046 26 28C26 26.8954 25.1046 26 24 26C22.8954 26 22 26.8954 22 28C22 29.1046 22.8954 30 24 30Z" fill="black" />
                                    <path d="M4.9806 2.8039C4.93527 2.57721 4.81279 2.37322 4.63401 2.22666C4.45522 2.08009 4.23118 2 4 2H0V4H3.18L7.0194 23.1961C7.06473 23.4228 7.18721 23.6268 7.36599 23.7733C7.54478 23.9199 7.76882 24 8 24H26V22H8.82L8.02 18H26C26.2275 18 26.4482 17.9224 26.6257 17.7801C26.8032 17.6377 26.9268 17.4391 26.9762 17.217L29.2445 7H27.1971L25.1982 16H7.62L4.9806 2.8039Z" fill="black" />
                                    <path d="M21.586 6.586L18 10.172V2H16V10.172L12.414 6.586L11 8L17 14L23 8L21.586 6.586Z" fill="black" />
                                </g>
                                <defs>
                                    <clipPath id="clip0_1076_1131">
                                        <rect width="32" height="32" fill="white" />
                                    </clipPath>
                                </defs>
                            </svg> */}
                        <svg
                          width="21"
                          height="21"
                          viewBox="0 0 17 17"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          onClick={(e) => {
                            navigate("/quote");
                          }}
                          style={{
                            verticalAlign: "sub",
                            marginRight: "6px",
                            cursor: "pointer",
                            // marginLeft: "1.2rem"
                          }}
                        >
                          <g clipPath="url(#clip0_395_13150)">
                            <path
                              fillRule="evenodd"
                              clipRule="evenodd"
                              d="M8.38883 2.70957C8.25322 2.67702 8.10142 2.67273 7.58051 2.67273L4.90599 2.67273C4.5378 2.67273 4.23933 2.37425 4.23933 2.00606C4.23933 1.63787 4.5378 1.3394 4.90599 1.3394L7.58051 1.3394C7.60345 1.3394 7.62608 1.33939 7.64843 1.33938C8.07176 1.33917 8.39162 1.33902 8.70009 1.41308C8.97218 1.4784 9.2323 1.58615 9.47089 1.73236C9.74137 1.89811 9.96744 2.12439 10.2666 2.42387C10.2824 2.43968 10.2984 2.4557 10.3147 2.47192L15.3774 7.53466C15.6377 7.79501 15.6377 8.21712 15.3774 8.47747C15.117 8.73782 14.6949 8.73782 14.4346 8.47747L9.37185 3.41473C9.0035 3.04639 8.89314 2.94208 8.77423 2.86921C8.65493 2.79611 8.52487 2.74223 8.38883 2.70957ZM7.50934 5.02448C7.45046 5.01035 7.38019 5.00606 7.02234 5.00606H5.03933C4.65496 5.00606 4.40677 5.00658 4.21788 5.02202C4.03677 5.03681 3.96963 5.06193 3.93667 5.07873C3.81122 5.14264 3.70924 5.24463 3.64532 5.37007C3.62853 5.40303 3.60341 5.47018 3.58861 5.65129C3.57318 5.84018 3.57266 6.08836 3.57266 6.47273L3.57266 7.78907C3.57266 8.14693 3.57694 8.2172 3.59108 8.27608C3.60741 8.3441 3.63435 8.40913 3.6709 8.46878C3.70254 8.52041 3.7492 8.57312 4.00224 8.82617L9.20224 14.0262C9.47403 14.298 9.64988 14.4731 9.79436 14.5957C9.93289 14.7133 9.99813 14.7431 10.0333 14.7545C10.1672 14.798 10.3114 14.798 10.4453 14.7545C10.4805 14.7431 10.5458 14.7133 10.6843 14.5957C10.8288 14.4731 11.0046 14.298 11.2764 14.0262L12.9261 12.3765C13.1979 12.1047 13.373 11.9288 13.4957 11.7844C13.6133 11.6458 13.643 11.5806 13.6544 11.5454C13.6979 11.4115 13.6979 11.2673 13.6544 11.1334C13.643 11.0982 13.6133 11.033 13.4957 10.8944C13.373 10.75 13.1979 10.5741 12.9261 10.3023L8.05943 5.43564C7.80639 5.1826 7.75367 5.13594 7.70204 5.1043C7.64239 5.06775 7.57736 5.04082 7.50934 5.02448ZM7.07787 3.6727C7.34914 3.67244 7.5883 3.67222 7.8206 3.72799C8.02467 3.77698 8.21976 3.85779 8.39871 3.96745C8.6024 4.09227 8.77135 4.26154 8.96299 4.45353C8.97596 4.46653 8.98904 4.47963 9.00224 4.49283L13.887 9.37764C14.1356 9.62614 14.35 9.84052 14.5121 10.0315C14.6833 10.2331 14.835 10.4521 14.9225 10.7214C15.053 11.1231 15.053 11.5557 14.9225 11.9574C14.835 12.2267 14.6833 12.4457 14.5121 12.6473C14.35 12.8383 14.1356 13.0526 13.8871 13.3011L12.201 14.9872C11.9526 15.2357 11.7382 15.45 11.5472 15.6122C11.3456 15.7833 11.1266 15.9351 10.8574 16.0226C10.4557 16.1531 10.023 16.1531 9.62129 16.0226C9.35204 15.9351 9.13305 15.7833 8.93146 15.6122C8.74046 15.45 8.5261 15.2357 8.27762 14.9872L3.05943 9.76897C3.04623 9.75578 3.03313 9.7427 3.02013 9.72973C2.82814 9.53809 2.65887 9.36914 2.53405 9.16544C2.42439 8.9865 2.34358 8.79141 2.29459 8.58734C2.23882 8.35504 2.23904 8.11587 2.23929 7.84461C2.23931 7.82625 2.23933 7.80774 2.23933 7.78907L2.23933 6.44704C2.23931 6.0956 2.2393 5.79243 2.25971 5.54271C2.28124 5.27915 2.32878 5.017 2.45731 4.76475C2.64906 4.38843 2.95502 4.08246 3.33134 3.89072C3.5836 3.76219 3.84574 3.71464 4.10931 3.69311C4.35902 3.67271 4.6622 3.67272 5.01363 3.67273L7.02234 3.67273C7.041 3.67273 7.05951 3.67271 7.07787 3.6727Z"
                              fill="currentColor"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_395_13150">
                              <rect
                                width="16"
                                height="16"
                                fill="white"
                                transform="translate(0.90625 0.672852)"
                              />
                            </clipPath>
                          </defs>
                        </svg>
                        {/* <svg
										width="21"
										height="21"
										viewBox="0 0 32 32"
										fill="none"
										xmlns="http://www.w3.org/2000/svg"
										onClick={(e) => {
											navigate("/quote");
										}}
										style={{ cursor: "pointer", marginLeft: "15px" }}
									>
										<g clipPath="url(#clip0_1090_5285)">
											<path
												d="M18.6666 2.66666H7.99992C6.53325 2.66666 5.33325 3.86666 5.33325 5.33332V26.6667C5.33325 28.1333 6.53325 29.3333 7.99992 29.3333H23.9999C25.4666 29.3333 26.6666 28.1333 26.6666 26.6667V10.6667L18.6666 2.66666ZM7.99992 26.6667V5.33332H17.3333V10.6667H23.9999V26.6667H7.99992ZM14.6666 25.3333H17.3333V24H18.6666C19.3999 24 19.9999 23.4 19.9999 22.6667V18.6667C19.9999 17.9333 19.3999 17.3333 18.6666 17.3333H14.6666V16H19.9999V13.3333H17.3333V12H14.6666V13.3333H13.3333C12.5999 13.3333 11.9999 13.9333 11.9999 14.6667V18.6667C11.9999 19.4 12.5999 20 13.3333 20H17.3333V21.3333H11.9999V24H14.6666V25.3333Z"
												fill="black"
											/>
										</g>
										<defs>
											<clipPath id="clip0_1090_5285">
												<rect width="32" height="32" fill="white" />
											</clipPath>
										</defs>
									</svg> */}
                      </Badge>
                    </span>
                  </Tooltip>
                )}
            </>
          )}
          {/* {(props.menuPaths.includes('/cart') || props.publicBrowsing) && preSelectedCustomer && preSelectedCustomer.ban &&
                        // (props.providerType === 'SALES_CHNL_PROVIDER' || props.providerType === 'SOLUTION_PROVIDER') &&
                        (props.shoppingCart && Array.isArray(props.shoppingCart) && props.shoppingCart.length === 0) || !preSelectedCustomer &&
                        <>
                            <Tooltip title={props.t('CART')}>
                                <Badge badgeContent={0} color="primary" className="cartBadgeIcon" overlap={'rectangular'}>
                                    <img onClick={(e) => { navigate('/cart') }} style={{ cursor: 'pointer' }} src={cartIcon} />
                                </Badge>
                            </Tooltip>
                        </>
                    } */}
        </div>
        {/* <div className="cl"></div> */}
      </div>
      {sideMenu ? (
        !props.publicBrowsing && (
          <ResponsiveDrawer
            menuPaths={props.menuPaths}
            userPerms={props.userPerms}
            loggedInUserType={props.loggedInUserType}
            openOperPortal={openOperPortal}
            access_token={props.access_token}
            tenantId={props.tenantId}
            providerType={props.providerType}
            closeOthers={props.closeOthers}
            open={props.open}
            updatedTenantId={updatedTenantId}
            updatedLoggedInUserId={updatedLoggedInUserId}
            updatedAccessToken={updatedAccessToken}
            operationLinkButtonRef={operationLinkButtonRef}
            anchorRef={anchorRef}
            quoteEnabled={props.quoteEnabled}
            genericReportsList={props.genericReports}
          />
        )
      ) : (
        <div
          className={sideMenu ? "newBottomHeaderSideMenu" : "newBottomHeader"}
          align="center"
          style={{ paddingBottom: "10rem !important" }}
        >
          <nav
            className={classes.navMenu}
            aria-label="Global site navigation."
            style={{
              borderRight: "1px solid lightgrey",
              borderTop: "1px solid lightgrey",
            }}
          >
            {/* Admin menus start */}
            {/* {props.userPerms.includes("CUMULATOR-PLATFORM_ADMIN") &&
                        <>
                            <div onMouseLeave={closeOthers}>
                                <StyledButton
                                    className={classes.newMenuItem}
                                    ref={anchorRefSer}
                                    aria-controls={serOpen ? 'menu-list-ser' : undefined}
                                    aria-haspopup="true"
                                    onMouseEnter={(e) => { handleSerExpand() }}
                                >
                                    {props.t('ADD_NEW')}
                                </StyledButton>
                                <Popper open={serOpen} anchorEl={anchorRefSer.current} role={undefined} transition disablePortal style={sideMenu ? {} : { top: '0 !important' }} placement={sideMenu ? "right-end" : "top"}>
                                    {({ TransitionProps, placement }) => (
                                        <Grow
                                            {...TransitionProps}
                                            style={{ transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom' }}
                                        >
                                            <Paper className={'custom_drop_down_ui'}>
                                                <ClickAwayListener onClickAway={handleSerClose}>
                                                    <MenuList autoFocusItem={solOpen} id="menu-list-ser" onKeyDown={handleSerListKeyDown}>
                                                        <MenuItem onClick={(e) => { handleSerClose(e); navigate('/providers/SALES_CHNL_PROVIDER'); }}>{props.t('SALES_CHANNEL_PROVIDER')}</MenuItem>
                                                        <MenuItem onClick={(e) => { handleSerClose(e); navigate('/providers/SOLUTION_PROVIDER'); }}>{props.t('SOLUTION_PROVIDER')}</MenuItem>
                                                        <MenuItem onClick={(e) => { handleSerClose(e); navigate('/providers/SERVICE_PROVIDER'); }}>{props.t('SERVICE_PROVIDER')}</MenuItem>
                                                    </MenuList>
                                                </ClickAwayListener>
                                            </Paper>
                                        </Grow>
                                    )}
                                </Popper>
                            </div>
                            <div onMouseLeave={closeOthers}>
                                <StyledButton
                                    className={classes.newMenuItem}
                                    ref={anchorRefOrder}
                                    aria-controls={orderOpen ? 'menu-list-order' : undefined}
                                    aria-haspopup="true"
                                    onMouseEnter={(e) => { handleOrderExpand() }}
                                >
                                    {props.t('MANAGE')}
                                </StyledButton>
                                <Popper open={orderOpen} anchorEl={anchorRefOrder.current} role={undefined} transition disablePortal style={sideMenu ? {} : { top: '0 !important' }} placement={sideMenu ? "right-end" : "top"}>
                                    {({ TransitionProps, placement }) => (
                                        <Grow
                                            {...TransitionProps}
                                            style={{ transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom' }}
                                        >
                                            <Paper className={'custom_drop_down_ui'}>
                                                <ClickAwayListener onClickAway={handleOrderClose}>
                                                    <MenuList autoFocusItem={orderOpen} id="menu-list-order" onKeyDown={handleOrderListKeyDown}>
                                                        <MenuItem onClick={(e) => { handleOrderClose(e); navigate('/manageSalesChannels'); }}>{props.t('SALES_CHANNEL_PROVIDER')}</MenuItem>
                                                        <MenuItem onClick={(e) => { handleOrderClose(e); navigate('/manageSolutionProviders'); }}>{props.t('SOLUTION_PROVIDER')}</MenuItem>
                                                        <MenuItem onClick={(e) => { handleOrderClose(e); navigate('/manageServiceProviders'); }}>{props.t('SERVICE_PROVIDER')}</MenuItem>
                                                    </MenuList>
                                                </ClickAwayListener>
                                            </Paper>
                                        </Grow>
                                    )}
                                </Popper>
                            </div>
                        </>
                    } */}
            {/* Admin menus end */}

            {props.providerType === "SERVICE_PROVIDER" && (
              <div onMouseLeave={closeOthers}>
                <StyledButton
                  className={classes.newMenuItem}
                  ref={anchorRefSer}
                  aria-controls={serOpen ? "menu-list-ser" : undefined}
                  aria-haspopup="true"
                  onClick={(e) => {
                    navigate("/product");
                    handleSerCollapse();
                  }}
                  onMouseEnter={(e) => {
                    handleSerExpand();
                  }}
                >
                  {props.t("SERVICES")}
                </StyledButton>
                {(props.userPerms.includes("CATALOG_ADMIN_ALL") ||
                  props.userPerms.includes("CATALOG_CREATE") ||
                  props.userPerms.includes("CATALOG_ADMIN") ||
                  props.userPerms.includes("CATALOG_VIEW")) && (
                    <Popper
                      open={serOpen}
                      anchorEl={anchorRefSer.current}
                      role={undefined}
                      transition
                      disablePortal
                      className={classes.newSubMenu}
                    >
                      {({ TransitionProps, placement }) => (
                        <Grow
                          {...TransitionProps}
                          style={{
                            transformOrigin:
                              placement === "bottom"
                                ? "center top"
                                : "center bottom",
                          }}
                        >
                          <Paper className={"custom_drop_down_ui"}>
                            <ClickAwayListener onClickAway={handleSerClose}>
                              <MenuList
                                autoFocusItem={solOpen}
                                id="menu-list-ser"
                                onKeyDown={handleSerListKeyDown}
                              >
                                {props.menuPaths.includes("/createPackage") && (
                                  <MenuItem
                                    onClick={(e) => {
                                      handleSerClose(e);
                                      navigate("/createPackage");
                                    }}
                                  >
                                    {props.t("ADD_NEW")}
                                  </MenuItem>
                                )}

                                {props.menuPaths.includes("/myOfferings") && (
                                  <MenuItem
                                    onClick={(e) => {
                                      handleSerClose(e);
                                      navigate("/myOfferings");
                                    }}
                                  >
                                    {props.t("EDIT")}
                                  </MenuItem>
                                )}
                              </MenuList>
                            </ClickAwayListener>
                          </Paper>
                        </Grow>
                      )}
                    </Popper>
                  )}
              </div>
            )}
            {
              // (props.providerType === 'SALES_CHNL_PROVIDER' || props.providerType === 'SOLUTION_PROVIDER') &&
              // (props.loggedInUserType != "ECOMMERCE_CUSTOMER" && props.loggedInUserType !== 'SALES_REPRESENTATIVE') &&
              // // New Menu
              <>
                {(props.providerType === "SALES_CHNL_PROVIDER" ||
                  props.providerType === "SOLUTION_PROVIDER") &&
                  props.menuPaths.includes("/dashboard") &&
                  !props.securityGroupsList.includes("PARTNER_EMPLOYEE") && (
                    <StyledButton
                      className={
                        classes.newMenuItem +
                        " hoverMenuItem " +
                        (location.pathname === "/manageCustomers" &&
                          "activeMenuItem")
                      }
                      ref={anchorRef}
                      aria-controls={open ? "menu-list-mc" : undefined}
                      aria-haspopup="true"
                      onClick={(e) => {
                        navigate("/dashboard");
                      }}
                      onMouseEnter={(e) => {
                        closeOthers();
                      }}
                    >
                      {props.t("DASHBOARD")}
                    </StyledButton>
                  )}
                {(props.userPerms.includes("CATALOG_ADMIN_ALL") ||
                  props.userPerms.includes("CATALOG_CREATE") ||
                  props.userPerms.includes("CATALOG_ADMIN") ||
                  props.userPerms.includes("CATALOG_VIEW")) && (
                    <div
                      className={classes.purchaseOrderMenuItems}
                      onMouseLeave={closeOthers}
                    >
                      {props.menuPaths.includes("/myOfferings") && (
                        <StyledButton
                          className={
                            classes.newMenuItem +
                            " hoverMenuItem " +
                            (location.pathname === "/myOfferings" &&
                              "activeMenuItem")
                          }
                          ref={anchorRefSol}
                          aria-controls={solOpen ? "menu-list-sol" : undefined}
                          aria-haspopup="true"
                          onClick={(e) => {
                            navigate("/myOfferings");
                            handleSolCollapse();
                          }}
                          onMouseEnter={(e) => {
                            handleSolExpand();
                          }}
                        >
                          {props.t("SOLUTIONS")}
                        </StyledButton>
                      )}
                    </div>
                  )}
                {/*Need to block this for ecommerce customer and  sales rep - should not though, TODO SWARN...*/}
                {(props.loggedInUserType != "ECOMMERCE_CUSTOMER" ||
                  props.loggedInUserType != "ECOMMERCE_ADMIN" ||
                  props.loggedInUserType != "SALES_REPRESENTATIVE") &&
                  (props.userPerms.includes("CATALOG_ADMIN_ALL") ||
                    props.userPerms.includes("CATALOG_CREATE") ||
                    props.userPerms.includes("CATALOG_ADMIN") ||
                    props.userPerms.includes("CATALOG_VIEW")) && (
                    <div
                      className={classes.purchaseOrderMenuItems}
                      onMouseLeave={closeOthers}
                    >
                      {props.menuPaths.includes("/products") && (
                        <StyledButton
                          className={
                            classes.newMenuItem +
                            " hoverMenuItem " +
                            (location.pathname === "/products" &&
                              "activeMenuItem")
                          }
                          ref={anchorRefSol}
                          aria-controls={solOpen ? "menu-list-sol" : undefined}
                          aria-haspopup="true"
                          onClick={(e) => {
                            navigate("/products");
                            handleSolCollapse();
                          }}
                          onMouseEnter={(e) => {
                            handleSolExpand();
                          }}
                        >
                          {props.t("PRODUCTS")}
                        </StyledButton>
                      )}
                    </div>
                  )}
              </>
            }

            {props.publicBrowsing && (
              <div style={{ width: "100%", textAlign: "left" }}>
                <StyledButton
                  className={classes.newMenuItem + " hoverMenuItem"}
                  ref={anchorRef}
                  aria-controls={open ? "menu-list-contract" : undefined}
                  aria-haspopup="true"
                  onClick={(e) => {
                    navigate("/solutions");
                  }}
                  style={{ marginLeft: "20%" }}
                  onMouseEnter={(e) => {
                    closeOthers();
                  }}
                >
                  {props.t("SOLUTIONS")}
                </StyledButton>
              </div>
            )}

            {
              /*(props.loggedInUserType === "ECOMMERCE_CUSTOMER" || props.loggedInUserType === "SALES_REPRESENTATIVE") &&*/
              <div>
                {props.userPerms.includes("CUMULATOR-PRODUCT_VIEW") &&
                  !props.menuPaths.includes("/myOfferings") && (
                    <StyledButton
                      className={
                        classes.newMenuItem +
                        " hoverMenuItem " +
                        (location.pathname === "/newOrder" && "activeMenuItem")
                      }
                      ref={anchorRef}
                      aria-controls={open ? "menu-list-contract" : undefined}
                      aria-haspopup="true"
                      onClick={(e) => {
                        navigate("/newOrder");
                      }}
                      onMouseEnter={(e) => {
                        closeOthers();
                      }}
                    >
                      {props.t("SOLUTIONS")}
                    </StyledButton>
                  )}
              </div>
            }
            {
              // pratyush - removed this line... props.providerType === 'SALES_CHNL_PROVIDER' &&
              // (props.loggedInUserType != "ECOMMERCE_CUSTOMER") &&
              <div>
                {props.menuPaths.includes("/manageCustomers") && (
                  <StyledButton
                    className={
                      classes.newMenuItem +
                      " hoverMenuItem " +
                      (location.pathname === "/manageCustomers" &&
                        "activeMenuItem")
                    }
                    ref={anchorRef}
                    aria-controls={open ? "menu-list-mc" : undefined}
                    aria-haspopup="true"
                    onClick={(e) => {
                      navigate("/manageCustomers");
                    }}
                    onMouseEnter={(e) => {
                      closeOthers();
                    }}
                  >
                    {props.loggedInUserType === "ECOMMERCE_CUSTOMER" ||
                      props.loggedInUserType === "ECOMMERCE_ADMIN"
                      ? props.t("ORGANIZATION")
                      : props.t("CUSTOMERS")}
                  </StyledButton>
                )}
              </div>
            }
            {props.menuPaths.includes("/manageLeads") &&
              props.loggedInUserType !== "ECOMMERCE_CUSTOMER" &&
              props.loggedInUserType !== "ECOMMERCE_ADMIN" && (
                <div>
                  <StyledButton
                    className={
                      classes.newMenuItem +
                      " hoverMenuItem " +
                      (location.pathname === "/manageLeads" && "activeMenuItem")
                    }
                    ref={anchorRef}
                    aria-controls={open ? "menu-list-mc" : undefined}
                    aria-haspopup="true"
                    onClick={(e) => {
                      navigate("/manageLeads");
                    }}
                    onMouseEnter={(e) => {
                      closeOthers();
                    }}
                  >
                    {props.t("LEADS")}
                  </StyledButton>
                </div>
              )}
            {props.providerType === "SALES_CHNL_PROVIDER" &&
              props.menuPaths.includes("/orders") &&
              modules.module_quote === "enabled" && (
                <div
                  className={classes.purchaseOrderMenuItems}
                  onMouseLeave={closeOthers}
                >
                  <StyledButton
                    className={
                      classes.newMenuItem +
                      " hoverMenuItem " +
                      ((location.pathname === "/quotes" ||
                        location.pathname.includes("/quote")) &&
                        "activeMenuItem")
                    }
                    ref={anchorRefOrder}
                    aria-controls={orderOpen ? "menu-list-order" : undefined}
                    aria-haspopup="true"
                    onClick={(e) => {
                      navigate("/quotes");
                      handleOrderCollapse();
                    }}
                    onMouseEnter={(e) => {
                      handleOrderExpand();
                    }}
                  >
                    {props.t("QUOTES")}
                  </StyledButton>
                </div>
              )}
            {
              /*(props.providerType === 'SALES_CHNL_PROVIDER' || props.providerType === 'SOLUTION_PROVIDER' || props.providerType === 'SERVICE_PROVIDER') && */
              props.menuPaths.includes("/orders") && (
                <div
                  className={classes.purchaseOrderMenuItems}
                  onMouseLeave={closeOthers}
                >
                  <StyledButton
                    className={
                      classes.newMenuItem +
                      " hoverMenuItem " +
                      ((location.pathname === "/orders" ||
                        location.pathname.includes("/order/")) &&
                        "activeMenuItem")
                    }
                    ref={anchorRefOrder}
                    aria-controls={orderOpen ? "menu-list-order" : undefined}
                    aria-haspopup="true"
                    onClick={(e) => {
                      navigate("/orders");
                      handleOrderCollapse();
                    }}
                    onMouseEnter={(e) => {
                      handleOrderExpand();
                    }}
                  >
                    {props.t("ORDERS")}
                  </StyledButton>
                </div>
              )
            }
            {/* {(props.providerType === 'SOLUTION_PROVIDER' || props.providerType === 'SERVICE_PROVIDER') &&
                        <div>
                            <StyledButton
                                className={classes.newMenuItem}
                                onClick={(e) => { navigate('/orders') }}
                                onMouseEnter={(e) => { closeOthers() }}>
                                Orders
                            </StyledButton>
                        </div>
                    } */}
            {props.menuPaths.includes("/contracts") && ( // pratyush removed (permission change) (props.loggedInUserType != "ECOMMERCE_CUSTOMER") &&
              <div>
                <StyledButton
                  className={
                    classes.newMenuItem +
                    " hoverMenuItem " +
                    ((location.pathname.includes("/contracts") ||
                      location.pathname.includes("/contract/")) &&
                      "activeMenuItem")
                  }
                  ref={anchorRef}
                  aria-controls={open ? "menu-list-contract" : undefined}
                  aria-haspopup="true"
                  onClick={(e) => {
                    navigate("/contracts");
                  }}
                  onMouseEnter={(e) => {
                    closeOthers();
                  }}
                >
                  {props.t("CONTRACTS")}
                </StyledButton>
              </div>
            )}
            {/* {(props.loggedInUserType != "ECOMMERCE_CUSTOMER") &&
                        <div>
                            <StyledButton
                                ref={anchorRef}
                                className={classes.newMenuItem}
                                aria-controls={open ? 'menu-list-settle' : undefined}
                                aria-haspopup="true"
                                onMouseEnter={(e) => { closeOthers() }}
                                onClick={(e) => { navigate('/workOrders') }}>
                                {props.t('WORK_ORDERS')}
                            </StyledButton>
                        </div>
                    } */}
            {props.menuPaths.includes("/subscriptions") && (
              // (props.providerType === 'SALES_CHNL_PROVIDER' || props.providerType === 'SOLUTION_PROVIDER') &&
              <div>
                <StyledButton
                  className={
                    classes.newMenuItem +
                    " hoverMenuItem " +
                    (location.pathname === "/subscriptions" && "activeMenuItem")
                  }
                  ref={anchorRef}
                  aria-controls={open ? "menu-list-sub" : undefined}
                  aria-haspopup="true"
                  onMouseEnter={(e) => {
                    closeOthers();
                  }}
                  onClick={(e) => {
                    navigate("/subscriptions");
                  }}
                >
                  {props.t("SUBSCRIPTIONS")}
                </StyledButton>
              </div>
            )}
            {props.menuPaths.includes("/subscriptions") && (
              // (props.providerType === 'SALES_CHNL_PROVIDER' || props.providerType === 'SOLUTION_PROVIDER') &&
              <div>
                <StyledButton
                  className={
                    classes.newMenuItem +
                    " hoverMenuItem " +
                    (location.pathname === "/assets" && "activeMenuItem")
                  }
                  ref={anchorRef}
                  aria-controls={open ? "menu-list-sub" : undefined}
                  aria-haspopup="true"
                  onMouseEnter={(e) => {
                    closeOthers();
                  }}
                  onClick={(e) => {
                    navigate("/assets");
                  }}
                >
                  {props.t("ASSETS")}
                </StyledButton>
              </div>
            )}
            {props.menuPaths.includes("/subscriptionAdjustments") && (
              // (props.providerType === 'SALES_CHNL_PROVIDER' || props.providerType === 'SOLUTION_PROVIDER') &&
              <div>
                <StyledButton
                  className={
                    classes.newMenuItem +
                    " hoverMenuItem " +
                    (location.pathname === "/subscriptionAdjustments" &&
                      "activeMenuItem")
                  }
                  ref={anchorRef}
                  aria-controls={open ? "menu-list-sub" : undefined}
                  aria-haspopup="true"
                  onMouseEnter={(e) => {
                    closeOthers();
                  }}
                  onClick={(e) => {
                    navigate("/subscriptionAdjustments");
                  }}
                >
                  {props.t("SUBSCRIPTION_ADJUSTMENTS")}
                </StyledButton>
              </div>
            )}
            {props.menuPaths.includes("/billing") && (
              //props.providerType === 'SALES_CHNL_PROVIDER' &&
              // (props.loggedInUserType != "ECOMMERCE_CUSTOMER") &&
              <div>
                <StyledButton
                  className={
                    classes.newMenuItem +
                    " hoverMenuItem " +
                    (location.pathname === "/billing" && "activeMenuItem")
                  }
                  ref={anchorRef}
                  aria-controls={open ? "menu-list-billr" : undefined}
                  aria-haspopup="true"
                  onMouseEnter={(e) => {
                    closeOthers();
                  }}
                  onClick={(e) => {
                    navigate("/billing");
                  }}
                >
                  {/* onClick={(e) => { navigate('/billingRecords') }}> */}
                  {props.t("BILLING")}
                </StyledButton>
              </div>
            )}
            <div>
              {props.menuPaths.includes("/asset") && (
                <StyledButton
                  ref={anchorRef}
                  className={
                    classes.newMenuItem +
                    " hoverMenuItem " +
                    (location.pathname === "/asset" && "activeMenuItem")
                  }
                  aria-controls={open ? "menu-list-settle" : undefined}
                  aria-haspopup="true"
                  onMouseEnter={(e) => {
                    closeOthers();
                  }}
                  onClick={(e) => {
                    navigate("/asset");
                  }}
                >
                  {props.t("ASSET")}
                </StyledButton>
              )}
            </div>
            {props.menuPaths.includes("/settlement") &&
              props.loggedInUserType !== "ECOMMERCE_CUSTOMER" &&
              props.loggedInUserType !== "ECOMMERCE_ADMIN" && (
                <div>
                  <StyledButton
                    className={
                      classes.newMenuItem +
                      " hoverMenuItem " +
                      (location.pathname === "/settlement" && "activeMenuItem")
                    }
                    ref={anchorRef}
                    aria-controls={open ? "menu-list-settle" : undefined}
                    aria-haspopup="true"
                    onMouseEnter={(e) => {
                      closeOthers();
                    }}
                    onClick={(e) => {
                      navigate("/settlement");
                    }}
                  >
                    {props.t("SETTLEMENTS")}
                  </StyledButton>
                </div>
              )}
            {
              props.userPerms.includes("CUMULATOR-REPORT_VIEW") && (
                //props.providerType === 'SALES_CHNL_PROVIDER' &&
                //(props.loggedInUserType != "ECOMMERCE_CUSTOMER") &&
                <div
                  className={classes.purchaseOrderMenuItems}
                  onMouseLeave={closeOthers}
                >
                  <StyledButton
                    className={
                      classes.newMenuItem +
                      " hoverMenuItem " +
                      ((location.pathname === "/orderReport" ||
                        location.pathname === "/billingRecords" ||
                        location.pathname === "/inventoryReport" ||
                        location.pathname === "/inventoryReceiptReport" ||
                        location.pathname === "/paymentReport" ||
                        location.pathname === "/workOrders" ||
                        location.pathname === "/stats" ||
                        location.pathname.includes("/report/")) &&
                        "activeMenuItem")
                    }
                    ref={anchorRefReportAv}
                    aria-controls={avReportOpen ? "menu-list-av" : undefined}
                    aria-haspopup="true"
                    onMouseEnter={(e) => {
                      closeOthers();
                      handleAvReportExpand();
                    }}
                  >
                    {props.t("REPORTS")}
                  </StyledButton>
                  <Popper
                    open={avReportOpen}
                    anchorEl={anchorRefReportAv.current}
                    role={undefined}
                    transition
                    disablePortal
                    style={sideMenu ? {} : { top: "0 !important" }}
                    placement={
                      sideMenu
                        ? "right-end"
                        : props.providerType === "SOLUTION_PROVIDER"
                          ? "bottom"
                          : "top"
                    }
                  >
                    {({ TransitionProps, placement }) => (
                      <Grow
                        {...TransitionProps}
                        style={{
                          transformOrigin:
                            placement === "bottom"
                              ? "center top"
                              : "center bottom",
                        }}
                      >
                        <Paper className={"custom_drop_down_ui"}>
                          <ClickAwayListener onClickAway={handleAvReportClose}>
                            <MenuList
                              autoFocusItem={avReportOpen}
                              id="menu-list-av"
                              onKeyDown={handleAvReportListKeyDown}
                            >
                              {props.loggedInUserType !==
                                "ECOMMERCE_CUSTOMER" &&
                                props.loggedInUserType !==
                                "ECOMMERCE_ADMIN" && (
                                  <>
                                    {/* {props.provderType === 'SALES_CHNL_PROVIDER' && (
																		<MenuItem
																			onClick={(e) => {
																				handleAvReportClose(e);
																				{
																					navigate("/dashboardReports");
																				}
																			}}
																		>
																			{props.t("DASHBOARD")}
																		</MenuItem>
																	)} */}
                                    {props.menuPaths.includes(
                                      "/orderReport",
                                    ) && (
                                        <MenuItem
                                          onClick={(e) => {
                                            handleAvReportClose(e);
                                            {
                                              navigate("/orderReport");
                                            }
                                          }}
                                        >
                                          {props.t("SALES_ORDER")}
                                        </MenuItem>
                                      )}
                                    {props.providerType !==
                                      "SOLUTION_PROVIDER" && (
                                        <>
                                          {props.menuPaths.includes(
                                            "/billingRecords",
                                          ) && (
                                              <MenuItem
                                                onClick={(e) => {
                                                  handleAvReportClose(e);
                                                  {
                                                    navigate("/billingRecords");
                                                  }
                                                }}
                                              >
                                                {props.t("BILLING_REPORTS")}
                                              </MenuItem>
                                            )}
                                          {/* New Added */}
                                          {props.menuPaths.includes(
                                            "/inventoryReport",
                                          ) && (
                                              <MenuItem
                                                onClick={(e) => {
                                                  handleAvReportClose(e);
                                                  {
                                                    navigate("/inventoryReport");
                                                  }
                                                }}
                                              >
                                                {props.t("INVENTORY")}
                                              </MenuItem>
                                            )}
                                          {/* {props.menuPaths.includes('/inventoryReceiptReport') &&
                                                        <MenuItem onClick={(e) => {
                                                            handleAvReportClose(e);
                                                            {
                                                                navigate('/inventoryReceiptReport')
                                                            }
                                                            ;
                                                        }}>{props.t('INVENTORY_RECEIPT')}</MenuItem>
                                                    } */}
                                          {props.menuPaths.includes(
                                            "/paymentReport",
                                          ) && (
                                              <MenuItem
                                                onClick={(e) => {
                                                  handleAvReportClose(e);
                                                  {
                                                    navigate("/paymentReport");
                                                  }
                                                }}
                                              >
                                                {props.t("PAYMENT_RECEIPT")}
                                              </MenuItem>
                                            )}
                                          {props.menuPaths.includes(
                                            "/workOrders",
                                          ) && (
                                              <MenuItem
                                                onClick={(e) => {
                                                  handleAvReportClose(e);
                                                  {
                                                    navigate("/workOrders");
                                                  }
                                                }}
                                              >
                                                {props.t("WORK_ORDERS")}
                                              </MenuItem>
                                            )}
                                          {/* New Added End */}
                                          {props.menuPaths.includes("/stats") && (
                                            <MenuItem
                                              onClick={(e) => {
                                                handleAvReportClose(e);
                                                {
                                                  navigate("/stats");
                                                }
                                              }}
                                            >
                                              {props.t("STATS")}
                                            </MenuItem>
                                          )}
                                        </>
                                      )}
                                  </>
                                )}
                              {/* Generic reports list */}
                              {props.loggedInUserType ===
                                "ECOMMERCE_CUSTOMER" ||
                                props.loggedInUserType === "ECOMMERCE_ADMIN"
                                ? genericReportsList.map(
                                  (item, index) =>
                                    (item.name ===
                                      "getItemsShippedToCustomer" ||
                                      item.name ===
                                      "getInventoryReceiptReport") && (
                                      <MenuItem
                                        key={index}
                                        onClick={(e) => {
                                          handleAvReportClose(e);
                                          navigate(`/report/${item.name}`, {
                                            state: {
                                              inputParameters: item.inputParameters || [],
                                              reportDescription: item.description,
                                              customFilter: item.customFilter || [],
                                            },
                                          });
                                        }}
                                      >
                                        {item.description}
                                      </MenuItem>
                                    ),
                                )
                                : genericReportsList.map(
                                  (item, index) =>
                                    item.name !==
                                    "getSolutionProviderSettlements" && (
                                      <MenuItem
                                        key={index}
                                        onClick={(e) => {
                                          handleAvReportClose(e);
                                          navigate(`/report/${item.name}`, {
                                            state: {
                                              inputParameters: item.inputParameters || [],
                                              reportDescription: item.description,
                                              customFilter: item.customFilter || [],
                                            },
                                          });
                                        }}
                                      >
                                        {item.description}
                                      </MenuItem>
                                    ),
                                )}
                            </MenuList>
                          </ClickAwayListener>
                        </Paper>
                      </Grow>
                    )}
                  </Popper>
                </div>
              )
              // TODO: Uncomment it later
              /* {<div>
              <StyledButton
                className={classes.newMenuItem}
                ref={anchorRef}
                aria-controls={open ? 'menu-list-billr' : undefined}
                aria-haspopup="true"
                onMouseEnter={(e) => { closeOthers() }}
                onClick={(e) => { handleAvReportClose(e); { navigate('/partSearch') }; }}>
                {props.t('PART_SEARCH')}
              </StyledButton>
            </div> } */
            }
            {
              // props.loggedInUserType !== "ECOMMERCE_CUSTOMER" && props.loggedInUserType !== 'SALES_REPRESENTATIVE' &&
              <>
                {
                  // props.providerType === 'SALES_CHNL_PROVIDER' &&
                  <div>
                    {
                      props.providerType === "SALES_CHNL_PROVIDER" &&
                      props.userPerms.includes("OFBTOOLS_VIEW") && (
                        <StyledButton
                          className={classes.newMenuItem + " hoverMenuItem"}
                          ref={anchorRef}
                          aria-controls={open ? "menu-list-billr" : undefined}
                          aria-haspopup="true"
                          onMouseEnter={(e) => {
                            closeOthers();
                          }}
                          onClick={(e) => {
                            openOperPortal(
                              props.access_token,
                              props.tenantId,
                            );
                          }}
                        >
                          {props.t("OPER_PORTAL")}
                        </StyledButton>
                      )
                      // <a href={`${constants.cbizBaseUrl}/myportal/control/login`} target='_blank'>{props.t('OPER_PORTAL')}</a>
                    }
                  </div>
                }
              </>
            }
            {/* <div className="cl"></div> */}
          </nav>
        </div>
      )}
      <form
        action={`${constants.cbizBaseUrl}/myportal/control/oplogin`}
        method="POST"
        target="_blank"
        style={{ display: "none" }}
      >
        <input
          type="text"
          name="userTenantId"
          value={updatedTenantId}
          readOnly
        />
        <input
          type="text"
          name="USERNAME"
          value={updatedLoggedInUserId}
          readOnly
        />
        <input type="text" name="TOKEN" value={updatedAccessToken} readOnly />
        <button type="submit" ref={operationLinkButtonRef}>
          Submit
        </button>
      </form>
      <Loader loading={showLoading} />
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    privileges: state.auth.privileges,
    tenantData: state.auth.tenantData,
    providerType: state.auth.providerType,
    providerName: state.auth.providerName,
    loggedInUserType: state.auth.userLoginType,
    ecommerceCustData: state.auth.ecommerceCustData,
    isCbizAdmin: state.auth.isCbizAdmin,
    tenantId: state.auth.tenantId,
    loggedInUserName: state.auth.loggedInUserName,
    loggedInUserId: state.auth.loggedInUserId,
    solutionList: state.cart.solutions,
    accessoryList: state.cart.accessories,
    access_token: state.auth.access_token,
    menuPaths: state.auth.menuPaths,
    userPerms: state.auth.userPerms,
    publicBrowsing: state.auth.publicBrowsing,
    shoppingCart: state.cart.shoppingCart,
    tenantInfo: state.auth.tenantInfo,
    genericReports: state.auth.genericReports,
    shoppingQuote: state.quote.shoppingQuote,
    quoteEnabled: state.auth.quoteEnabled,
    pendingTaskCount: state.auth.pendingTaskCount,
    sideMenu: state.auth.sideMenu,
    securityGroupsList: state.auth.securityGroupsList,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    setCompDidMount: () =>
      dispatch({ type: actionTypes.GLOBAL_COMP_DID_MOUNT }),
    setErrorMessage: (errMsg, msgType) =>
      dispatch({ type: actionTypes.SET_ERROR_MSG, errMsg, msgType }),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation("translations")(BottomHeader));
